import React, { useEffect, useState } from "react";
import RouteManager, { PAGE_ROUTES } from "../../../managers/RouteManager";
import AppManager from "../../../managers/AppManager";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import {
    DKLabel,
    DKIcon,
    DKTooltipWrapper,
} from "deskera-ui-library";
import reports from '../../../assets/icons/report/Reports.svg';
import ic_info_gray from "../../../assets/icons/ic_info_gray.svg";
import { TENANT, TenantService } from "../../../managers/TenantManagerService";


function TimesheetReportList(props) {
    const history = useHistory();
    const { t } = useTranslation();

    const [reportList, setReportList] = useState([]);

    useEffect(() => {
        RouteManager.setPresenter({ props: { ...props, history: history } });
        AppManager.scrollToTop();

        setReportList([
            {
                id: "TIMESHEET_REPORT",
                title: "Timesheet Report",
                tooltip: "Timesheet Report",
                route: PAGE_ROUTES.TIMESHEET_REPORT,
                hidden: false
            },
            {
                id: "TIMESHEET_REPORT_GROUP",
                title: "Timesheet Report Group",
                tooltip: "Timesheet Report Group",
                route: PAGE_ROUTES.TIMESHEET_REPORT_GROUP,
                hidden: false
            }
        ]);
    }, []);

    return (
        <div className="parent-width">
            <DKLabel text="Timesheet Reports" className="fw-m fs-l" />
            <div className="parent-width d-flex mt-l">
                <div className="parent-width">
                    <div className="card-shadow border-radius-s parent-height">
                        <div className=" pt-l pl-l" style={{ backgroundColor: "#e2e3e2" }}>
                            <DKLabel className="fw-m fs-xl" text={"Timesheet Reports"} />
                            <div className="d-flex justify-content-end">
                                <img className="ic-xl " src={reports} />
                            </div>
                        </div>
                        <div className="border-radius-s" style={{ backgroundColor: "#f5f5f5" }}>
                            {reportList.map((report) => {
                                return (
                                    <div onClick={() => RouteManager.navigateToPage(report.route) }>
                                        <div className="d-flex align-items-center data-grid-header">
                                            <DKLabel text={report.title} className={`m-0 cursor-hand p-v-l pl-l`} />
                                            <div style={{ marginTop: "4px", marginLeft: "4px" }}>
                                                <DKTooltipWrapper content={report.tooltip} tooltipClassName="warning-tooltip-prop" >
                                                    <DKIcon src={ic_info_gray} className="ic-s mr-r cursor-hand" />
                                                </DKTooltipWrapper>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TimesheetReportList;
